const MobileApps = 'MobileApps';

// FETCH APP
export const FETCH_MOBILE_APP_REQUEST = `${MobileApps}/FETCH_MOBILE_APP_REQUEST`;
export const FETCH_MOBILE_APP_RESPONSE = `${MobileApps}/FETCH_MOBILE_APP_RESPONSE`;
export const FETCH_MOBILE_APP_ERROR = `${MobileApps}/FETCH_MOBILE_APP_ERROR`;

// FETCH APPS
export const FETCH_MOBILE_APPS_REQUEST = `${MobileApps}/FETCH_MOBILE_APPS_REQUEST`;
export const FETCH_MOBILE_APPS_RESPONSE = `${MobileApps}/FETCH_MOBILE_APPS_RESPONSE`;
export const FETCH_MOBILE_APPS_ERROR = `${MobileApps}/FETCH_MOBILE_APPS_ERROR`;

// CREATE APP
export const CREATE_MOBILE_APP_REQUEST = `${MobileApps}/CREATE_MOBILE_APP_REQUEST`;
export const CREATE_MOBILE_APP_RESPONSE = `${MobileApps}/CREATE_MOBILE_APP_RESPONSE`;
export const CREATE_MOBILE_APP_ERROR = `${MobileApps}/CREATE_MOBILE_APP_ERROR`;

// UPDATE APP
export const UPDATE_MOBILE_APP_REQUEST = `${MobileApps}/UPDATE_MOBILE_APP_REQUEST`;
export const UPDATE_MOBILE_APP_RESPONSE = `${MobileApps}/UPDATE_MOBILE_APP_RESPONSE`;
export const UPDATE_MOBILE_APP_ERROR = `${MobileApps}/UPDATE_MOBILE_APP_ERROR`;

// DELETE APP

export const DELETE_MOBILE_APP_REQUEST = `${MobileApps}/DELETE_MOBILE_APP_REQUEST`;
export const DELETE_MOBILE_APP_RESPONSE = `${MobileApps}/DELETE_MOBILE_APP_RESPONSE`;
export const DELETE_MOBILE_APP_ERROR = `${MobileApps}/DELETE_MOBILE_APP_ERROR`;

// FETCH INTEGRATIONS
export const FETCH_INTEGRATIONS_REQUEST = `${MobileApps}/FETCH_INTEGRATIONS_REQUEST`;
export const FETCH_INTEGRATIONS_RESPONSE = `${MobileApps}/FETCH_INTEGRATIONS_RESPONSE`;
export const FETCH_INTEGRATIONS_ERROR = `${MobileApps}/FETCH_INTEGRATIONS_ERROR`;

// CREATE INTEGRATIONS
export const CREATE_INTEGRATION_REQUEST = `${MobileApps}/CREATE_INTEGRATION_REQUEST`;
export const CREATE_INTEGRATION_RESPONSE = `${MobileApps}/CREATE_INTEGRATION_RESPONSE`;
export const CREATE_INTEGRATION_ERROR = `${MobileApps}/CREATE_INTEGRATION_ERROR`;

// ASSIGN INTEGRATIONS
export const ASSIGN_INTEGRATION_REQUEST = `${MobileApps}/ASSIGN_INTEGRATION_REQUEST`;
export const ASSIGN_INTEGRATION_RESPONSE = `${MobileApps}/ASSIGN_INTEGRATION_RESPONSE`;
export const ASSIGN_INTEGRATION_ERROR = `${MobileApps}/ASSIGN_INTEGRATION_ERROR`;

// UPDATE INTEGRATIONS
export const UPDATE_INTEGRATION_REQUEST = `${MobileApps}/UPDATE_INTEGRATION_REQUEST`;
export const UPDATE_INTEGRATION_RESPONSE = `${MobileApps}/UPDATE_INTEGRATION_RESPONSE`;
export const UPDATE_INTEGRATION_ERROR = `${MobileApps}/UPDATE_INTEGRATION_ERROR`;

// DELETE INTEGRATIONS
export const DELETE_INTEGRATION_REQUEST = `${MobileApps}/DELETE_INTEGRATION_REQUEST`;
export const DELETE_INTEGRATION_RESPONSE = `${MobileApps}/DELETE_INTEGRATION_RESPONSE`;
export const DELETE_INTEGRATION_ERROR = `${MobileApps}/DELETE_INTEGRATION_ERROR`;

// TEST PUSH
export const SEND_TEST_PUSH_REQUEST = `${MobileApps}/SEND_TEST_PUSH_REQUEST`;
export const SEND_TEST_PUSH_RESPONSE = `${MobileApps}/SEND_TEST_PUSH_RESPONSE`;
export const SEND_TEST_PUSH_ERROR = `${MobileApps}/SEND_TEST_PUSH_ERROR`;
